import { cloneElement } from 'react';

import { SFStockoutItemChip } from '../sf-stockout-item-chip';

import { useSubstitutionFlowProductHOC } from './hooks';

import makeClasses from './SubstitutionFlowProductHOC.style';

import type { ReactElement, ReactNode } from 'react';
import type { OrderId, ProductId } from 'shared/domain';

export function SubstitutionFlowProductHOC(props: Props) {
  const { orderId, orderProductId, children } = props;

  const {
    hasReplacement,
    stockoutItem,
    replacementItem,
    formatedPrice,
  } = useSubstitutionFlowProductHOC({ orderId, orderProductId });

  const _classes = makeClasses();

  const showStockoutProductChip = !!stockoutItem;
  if (!showStockoutProductChip) return children;
  return (
    <article
      className={_classes.article}
      aria-label='substitution-flow-product-hoc'
      data-has-replacement={hasReplacement}
      data-order-product-id={stockoutItem.orderProductId}
    >
      {hasReplacement && (
        <section
          aria-label='replacement-product'
          data-product-id={replacementItem?.productId}
        >
          <header className={_classes.productHeader}>
            <h2>
              <span>{`${replacementItem?.units}x `}</span>
              {replacementItem?.name}
              <SFStockoutItemChip mode='replacement' />
            </h2>
            <span>{formatedPrice}</span>
          </header>
          <p className={_classes.productDescription}>
            {replacementItem?.description}
          </p>
        </section>
      )}

      <section
        aria-label='stockout-product'
        className={_classes.stockoutSection}
        data-has-replacement={hasReplacement}
        data-product-id={stockoutItem.productId}
      >
        {cloneElement(children as ReactElement, { showStockoutProductChip })}
      </section>
    </article>
  );
}

interface Props {
  orderId: OrderId;
  orderProductId: ProductId;
  children: ReactNode;
}
